import { Injectable } from '@angular/core';
import * as platform from 'platform';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Observer } from 'rxjs';

declare const gtag;

interface GeoLocationData {
  city: string;
  region: string;
  countryCode: string;
}

@Injectable()
export class EventTrackerService {
  public os = {architecture: '', family: '', version: ''};
  browser = {name: '', version: ''};
  platformDescription = '';
  ip = 'N/A';
  country = 'N/A';
  retrieveError = false;
  region = 'N/A';
  city = 'N/A';
  latitude = 0.0;
  longitude = 0.0;

  constructor(private http: HttpClient) {}

  /** Function to initialise the track event session **/
  initialise() {
    this.getLocation();
    this.getBrowserInformation();
  }

  /** Function to get the location of the click **/
  getLocation() {
    const headers = new HttpHeaders().set('Authorization', 'Bearer 582e6dd241fd5d');
    this.http.get('https://ipinfo.io', {headers: headers}).subscribe(data => {
      if (data) { // In some situations (not sure which?) this data is null
        const geoData = data;
        const latLng = geoData['loc'].split(',');
        this.latitude = parseFloat(latLng[0]);
        this.longitude = parseFloat(latLng[1]);
        this.country = geoData['country'];
        this.region = geoData['region'];
        this.city = geoData['city'];
        this.ip = geoData['ip'];
      }
    }, () => {
      this.retrieveError = true;
      this.country = 'ZA';
    });
  }

  /** If another service requires the country **/
  public getCountry(): Observable<string> {
    return new Observable<string>((observer: Observer<string>) => {
      this.extractCountry(observer);
    });
  }
  private extractCountry(observer) {
    if (this.country === 'N/A') {
      setTimeout(() => {
        this.extractCountry(observer);
      }, 300);
    } else {
      observer.next(this.country);
      observer.complete();
    }
  }

  /** If another service requires ip geolocation data post initialization **/
  public getIPGeolocationData(): GeoLocationData {
    return {
      city: this.city,
      region: this.region,
      countryCode: this.country
    };
  }

  /** Function to get the browser specific information **/
  getBrowserInformation() {
    this.platformDescription = platform.description;
    this.os = {architecture: platform.os.architecture, family: platform.os.family, version: platform.os.version};
    this.browser = {name: platform.name, version: platform.version};
  }

  /** Function which tracks a click and sends it to google analytics **/
  gtagTrack(category, label) {
    if (!['localhost', 'dev.aerobotics.com'].includes(window.location.hostname)) {
      gtag('event', 'click', {
        'event_category': category,
        'event_label': label
      });
    }
  }

  /** Function which tracks a page view and sends it to google analytics **/
  gtagPageTrack(pagePath: string, userId: number, staffUser: boolean) {
    if (!['localhost', 'dev.aerobotics.com'].includes(window.location.hostname)) {
      // If there is a userId present track the user for all subsequent gtag sessions along with the users staff status
      if (userId) {
        gtag('set', {
          'staff_user': staffUser,
          'user_id': userId,
          'new_platform': false
        });
      }
      // Log the page view
      gtag('config', 'UA-55974386-3', {
        'page_title': document.title,
        'page_path': pagePath,
        'user_id': userId,
        'custom_map': {
          'dimension1': 'staff_user',
          'dimension2': 'new_platform'
        }
      });
    }
  }
}
